import { cn } from '@/lib/utils'
import Link from 'next/link'

interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg'
  showDot?: boolean
  showTagline?: boolean
  href?: string
  className?: string
  onClick?: () => void
}

const sizeMap = {
  sm: { outer: 'w-7 h-7', text: 'text-xs', dot: 'w-2 h-2', name: 'text-base', tagline: false },
  md: { outer: 'w-9 h-9', text: 'text-sm', dot: 'w-2.5 h-2.5', name: 'text-lg', tagline: true },
  lg: { outer: 'w-11 h-11', text: 'text-base', dot: 'w-3 h-3', name: 'text-xl', tagline: true },
}

export function BrandLogo({
  size = 'md',
  showDot = true,
  showTagline = false,
  href = '/',
  className,
  onClick,
}: BrandLogoProps) {
  const s = sizeMap[size]

  const content = (
    <span className={cn('flex items-center gap-2.5 group', className)}>
      {/* Ícone com gradiente e status dot */}
      <span className="relative flex-shrink-0">
        <span
          className={cn(
            s.outer,
            'bg-gradient-to-br from-blue-600 to-violet-600 rounded-xl',
            'flex items-center justify-center',
            'shadow-lg shadow-blue-500/25 group-hover:shadow-blue-500/40',
            'transition-shadow duration-300',
          )}
        >
          <span className={cn('text-white font-bold', s.text)}>A</span>
        </span>
        {showDot && (
          <span
            className={cn(
              'absolute -top-0.5 -right-0.5 rounded-full bg-green-400',
              'border-2 border-white dark:border-slate-950',
              s.dot,
            )}
          />
        )}
      </span>

      {/* Nome + tagline */}
      <span className="hidden sm:flex flex-col leading-none">
        <span className={cn('font-bold tracking-tight text-gray-900 dark:text-white', s.name)}>
          AcheiVagas
        </span>
        {(showTagline || s.tagline) && showTagline && (
          <span className="text-[10px] text-muted-foreground tracking-wider uppercase mt-0.5">
            .com.br
          </span>
        )}
      </span>
    </span>
  )

  if (href) {
    return (
      <Link href={href} onClick={onClick} className="focus-visible:outline-none">
        {content}
      </Link>
    )
  }

  return (
    <button type="button" onClick={onClick} className="focus-visible:outline-none">
      {content}
    </button>
  )
}
